import React, { useEffect,useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import "./PrivacyPolicy.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';

const PrivacyPolicy = () => {
const [loading,setLoading] = useState(true);

const [inputs,setInputs] = useState({privacy_policy:''});
  useEffect(() => {
    document.title = `Privacy-Policy | Your Friend My Friend`;
    document.getElementById('bodywrap').className='pri';
	
	window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth', 
    }); 
	
	/* Start get page data */
		let formData = new FormData(); 
		formData.append('type', 'privacy_policy');
		API.post('get_page',formData)
			.then(response => {
				setLoading(false);
			if(response.data.status === false){
				
			}else{
			   setInputs({privacy_policy:response.data.data.privacy_policy});
			}                  
		}).catch(error => {
			 
		});  
	 /* End get page data */
	
  },[]);  

  return (
    <>
      <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/privacy-policy.jpg'}
          alt=""
          className="img-fluid d-none d-md-block"
        />

        {/* Mobile Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/privacy-policy.jpg'}
          alt=""
          className="img-fluid d-block d-md-none"
        />
      </div>

      <div className="container my-5">
        <div className="row">
            <div className="col-md-12 cousel">
                <h1>Privacy Policy</h1>
                <div dangerouslySetInnerHTML={{__html: inputs.privacy_policy}} />
            </div>
        </div>
      </div>
      <Appqr />
      <Footer />
	  {loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
    </>
  );
};

export default PrivacyPolicy;